import common from './modules/common.en-US'
import home from './modules/home.en-US'
import lighting from './modules/lighting.en-US'
import setting from './modules/setting.en-US'
import toast from './modules/toast.en-US'
import itinerary from './modules/itinerary.en-US'
import keys from './modules/keys.en-US'
import dpi from './modules/dpi.en-US'
import performance from './modules/performance.en-US'
import parameters from './modules/parameters.en-US'
import server from './modules/server.en-US'
import tray from './modules/tray.en-US'
import notice from './modules/notice.en-US'
import pageAndPlayer from './modules/pageAndPlayer.en-US'
import rt from './modules/rt.en-US'

export default {
  common,
  home,
  lighting,
  setting,
  toast,
  itinerary,
  keys,
  dpi,
  performance,
  parameters,
  server,
  tray,
  notice,
  pageAndPlayer,
  rt,
}
